/* tslint:disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: pdp-page
// ==============================
import 'build/HM9jouTdGN9XZjMsite/sass/core.scss'
import * as commandQueue from 'init/command-queue'
import globalStore from 'init/global-store'
import { checkTurntoflow } from 'email-flows/email-flow-entry'
import { loadConfig as loadGlobalConfig } from 'init/global.config'
import loadIcons from 'util/browser/load-icons'
import msg, { loadMessages } from 'services/msg'
import * as qaLoader from 'widgets/qa/qa-loader'
import * as instantAnswersLoader from 'widgets/instant-answers/instant-answers-loader'
import * as reviewsSummaryLoader from 'widgets/reviews-summary/reviews-summary-loader'
import * as reviewsListLoader from 'widgets/reviews-list/reviews-list-loader'
import * as chatterLoader from 'widgets/chatter/chatter-loader'
import * as topCommentsLoader from 'widgets/top-comments/top-comments-loader'
import { loadConfig as loadReviewSubmissionConfig } from 'widgets/submission/review-submission.config'
import tokenService from 'services/token-service'
// NOTE: For some reason, the loading of modules that was done through src/entry/base is
//       not working since upgrading to webpack 4.  Moved to here.
import Vue from 'vue'
import formatName from 'filters/format-name'
import Button from 'objects/button/button'
import Icon from 'objects/icon/icon'
import { hostsConfig, turnToConfig } from 'init/config'

// This is already set in turnto.js (turnto-entry), but if this is a multi-build site due to
// multiple themes with varying sass var sets, then each page will have the webpack manifest code
// and therefore needs to have it set here as it won't know about the one in turnto.js
const path = process.env.NODE_ENV === 'development' || process.env.testProdBuild ? '' : 'v5/widgets/'
__webpack_public_path__ = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}/${path}`

// makes these available to all Vue components
Vue.component('tt-button', Button)
Vue.component('tt-icon', Icon)
Vue.filter('formatName', formatName)
Vue.prototype.$msg = msg

if (turnToConfig.sku) {
  globalStore.sku = turnToConfig.sku
}

function loadConfig(config) {
  loadIcons(config.svg)
  loadMessages(config.messages, config.pluralRuleFn)
  loadGlobalConfig(config.globalConfig)
  Promise.all([
    qaLoader.loadWidget(config.qa),
    instantAnswersLoader.loadWidget(config.instantAnswers),
    reviewsSummaryLoader.loadWidget(config.reviewsSummary),
    reviewsListLoader.loadWidget(config.reviewsList),
    chatterLoader.loadWidget(config.chatter),
    topCommentsLoader.loadWidget(config.topComments)
  ]).then(() => {
    globalStore.loaders = [
      qaLoader,
      instantAnswersLoader,
      reviewsSummaryLoader,
      reviewsListLoader,
      chatterLoader,
      topCommentsLoader
    ]
    commandQueue.init()
  })
  tokenService.loadLoggedInUser()
  loadReviewSubmissionConfig(config.reviewSubmission)
  checkTurntoflow()
}

// window.TurnTo defined in the Webpack bootstrap code.  Insertion of this definition is done
// by the json-main-template-promise-plugin
window['TurnTo'].loadConfig = loadConfig
